import { hiddenOrderComponentNames } from '@moko/utils';
import type { IOtherInfoProps } from './types';

const NONE: ReadonlySet<string> = new Set();

export const hiddenOrderComponentsFor = (
  params: Pick<
    IOtherInfoProps,
    | 'metadata'
    | 'orderComponentOptions'
    | 'orderComponentOptionsLoading'
    | 'orderComponentOptionsError'
    | 'orderComponentCatalog'
  >,
  answers: Record<string, unknown>
): ReadonlySet<string> => {
  const options = params.orderComponentOptions;
  if (
    !options ||
    params.orderComponentOptionsLoading ||
    params.orderComponentOptionsError
  ) {
    return NONE;
  }
  return hiddenOrderComponentNames({
    fields: params.metadata.fields ?? [],
    answers,
    availableTimeServiceCodes: (options.TIME_SERVICE ?? [])
      .filter((option) => !option.disabled)
      .map((option) => option.key),
    catalog: params.orderComponentCatalog,
  });
};
